import {Trans} from '@ui/i18n/trans';
import {DescriptionIcon} from '@ui/icons/material/Description';
import React, {useEffect, useState} from 'react';
import {Accordion, AccordionItem} from '@ui/accordion/accordion';
import {LiensListDatatablePageAdmin} from '@app/admin/liens/liens-list-datatable-page';
import {NzbListDatatablePageAdmin} from '@app/admin/liens/nzb-list-datatable-page';
import {useOutletContext} from 'react-router-dom';
import {Title} from '@app/titles/models/title';
import {useTrans} from '@ui/i18n/use-trans';

export function LiensListPage({loader}: {loader: string}) {
  const {trans} = useTrans();
  const [expandedValues, setExpandedValues] = useState<number[]>(() => {
    const saved = localStorage.getItem('expandedAccordion');
    return saved ? JSON.parse(saved) : [0];
  });
  const data = useOutletContext<any>();
  const title = data.title as Title;
  useEffect(() => {
    localStorage.setItem('expandedAccordion', JSON.stringify(expandedValues));
  }, [expandedValues]);

  return (
    <div className="flex flex-col gap-12">
      <h2 className="m-20 text-center text-2xl">
        {title.name} ({title.year})
      </h2>
      <Accordion
        variant="default"
        expandedValues={expandedValues}
        onExpandedChange={values => setExpandedValues(values as number[])}
      >
        <AccordionItem
          label={
            <Trans
              message="Links List (:countLinks)"
              values={{
                countLinks:
                  loader == 'adminliens'
                    ? title.liens_count
                    : title.liens_by_user_count,
              }}
            />
          }
          startIcon={<DescriptionIcon />}
        >
          <LiensListDatatablePageAdmin loader={loader} title={title} />
        </AccordionItem>
        <AccordionItem
          label={
            <Trans
              message="Nzb List (:countNzbs)"
              values={{
                countNzbs:
                  loader == 'adminliens'
                    ? title.nzbs_count
                    : title.nzbs_by_user_count,
              }}
            />
          }
          startIcon={<DescriptionIcon />}
        >
          <NzbListDatatablePageAdmin title={title} loader={loader} />
        </AccordionItem>
      </Accordion>
    </div>
  );
}
